import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import imgNotFound from "../../../assets/images/single-image.png";
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import Skeleton from "react-loading-skeleton";
import PageMetaData from "../../PageMetaData/PageMetaData";
import OgMetaTitles from "../../PageMetaData/OgMetaTitles";
import Header from "../../Header/Header";
import NewUIHotelCard from "./NewUIHotelCard";
import NoDataFound from "../../NoDataFound/NoDataFound";
import CustomPagination from "../../CustomPagination/CustomPagination";
import Footer from "../../Footer/Footer";
import {
  currentDateSingle,
  formatIndianCurrency,
  scrollToTop,
} from "../../../utils/utils";
import AllHotelsSearchForm from "../../AllHotelsSearchForm/AllHotelsSearchForm";
import FilterSection from "../../FilterSection/FilterSection";
import BreadcrumbSchema from "../../Schema/BreadcrumbSchema";
import styles from "./NewUIHotelCard.module.scss";
import NewFooterUI from "../NewFooterUI/NewFooterUI";
import NewUiHeader from "../NewUIHeader/NewUIHeader";
import EditNewUiSearchFormHotels from "../NewUiSearchForm/NewUiSearchFormHotels/EditNewUiSearchFormHotels";
import NewFilterHotels from "../../FilterSection/NewFilterHotels";

function NewUIAllHotelsPage() {
  const location = useLocation();
  const [bookingData, setBookingData] = useState({});
  const [hotelData, setHotelData] = useState([]);
  const navigate = useNavigate();
  const [sortedFilter, setSortedFilter] = useState({
    show: "Popular",
    value: "popular",
  });

  useEffect(() => {
    localStorage.removeItem("roomsData");
    localStorage.removeItem("storeRoomsData");
  }, [navigate]);

  useEffect(() => {
    // console.log(sortedFilter.value);
    let dummyData = [...hotelData];
    if (sortedFilter?.value === "l2hByp") {
      dummyData.sort((a, b) => a.starting_price - b.starting_price);
      setHotelData(dummyData);
    }

    if (sortedFilter?.value === "h2lByp") {
      dummyData.sort((a, b) => b.starting_price - a.starting_price);
      setHotelData(dummyData);
    }
  }, [sortedFilter?.value]);

  const [loader, setLoader] = useState(true);
  const [filerLoader, setFilterLoader] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const displayedData =
    hotelData &&
    hotelData &&
    hotelData.length > 0 &&
    hotelData.slice(startIndex, endIndex);

  // useEffect(() => {
  //   const params = new URLSearchParams(location.search);
  //   const data = {
  //     hotelID: params.get("hotelID"),
  //     location: params.get("location"),
  //     room: params.get("room"),
  //     adult: params.get("adult"),
  //     children: params.get("children"),
  //     checkinDay: params.get("checkinDay"),
  //     checkinMonth: params.get("checkinMonth"),
  //     checkinYear: params.get("checkinYear"),
  //     checkoutDay: params.get("checkoutDay"),
  //     checkoutMonth: params.get("checkoutMonth"),
  //     checkoutYear: params.get("checkoutYear"),
  //     radio: params.get("radio"),
  //     childAge: params.get("childAge"),
  //   };
  //   setBookingData(data);
  //   postBookingData(data);
  // }, [location.search]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);

    // Get the childAge parameters
    const childAges = [];
    let i = 1;
    while (params.has(`childAge[${i}]`)) {
      childAges.push(params.get(`childAge[${i}]`));
      i++;
    }

    // const currentDate = new Date(currentDateSingle);
    // const checkOutDate = new Date(currentDate);
    // checkOutDate.setDate(checkOutDate.getDate() + 1);

    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() + 7); // One week from today

    const checkOutDate = new Date();
    checkOutDate.setDate(checkOutDate.getDate() + 8);


    const data = {
      // hotelID: params.get("hotelID"),
      location: params.get("location"),
      room: params.get("room"),
      adult: params.get("adult"),
      children: params.get("children"),
      // checkinDay: new Date(currentDate).getDate(),
      // checkinMonth: new Date(currentDate).getMonth() + 1,
      // checkinYear: new Date(currentDate).getFullYear(),
      // checkoutDay: new Date(currentDate).getDate() + 1,
      // checkoutMonth: new Date(currentDate).getMonth() + 1,
      // checkoutYear: new Date(currentDate).getFullYear(),


      checkinDay: currentDate.getDate(),
      checkinMonth: currentDate.getMonth() + 1,
      checkinYear: currentDate.getFullYear(),

      checkoutDay: checkOutDate.getDate(),
      checkoutMonth: checkOutDate.getMonth() + 1,
      checkoutYear: checkOutDate.getFullYear(),

      radio: params.get("radio"),
      childAge: childAges, // Assign the array of child ages
    };
    // console.log(hotelData, "data hotel")
    setBookingData(data);
    postBookingData(data);
  }, [location.search]);
  // console.log(items, "  data hotel")

  const postBookingData2 = async (data, filters) => {
    setFilterLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_API_KEY);

    const checkInDate = `${data.checkinYear}-${String(
      data.checkinMonth
    ).padStart(2, "0")}-${String(data.checkinDay).padStart(2, "0")}`;
    const checkOutDate = `${data.checkoutYear}-${String(
      data.checkoutMonth
    ).padStart(2, "0")}-${String(data.checkoutDay).padStart(2, "0")}`;

    const formdata = new FormData();
    {
      data.location && formdata.append("location", data.location);
    }
    // formdata.append("location", data.location);
    // formdata.append("limit", 2);

    // formdata.append("checkIn", checkInDate);
    // formdata.append("checkOut", checkOutDate);
    // formdata.append("adults", data.adult);
    // formdata.append("child", data.children);
    // formdata.append("location", data.location);
    // formdata.append("rooms", data.room);
    // formdata.append("PropertyType", data?.radio ? data?.radio : "hotel");

    // Append childAge values dynamically
    if (data.children > 0) {
      for (let i = 1; i <= data.children; i++) {
        formdata.append(`childAge[${i - 1}]`, data.childAge[i - 1]);
      }
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_APP_URL
        }/api/v1/hotel-engine/check-availability?star_rating=${
          filters?.stars ? filters?.stars : ""
        }&price_range=${filters?.budget ? filters?.budget : ""}`,
        requestOptions
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();
      setHotelData(result.data.properties);
    } catch (error) {
      console.error("Error fetching data:", error.message);
      // Display error message in a toast or alert
      // showErrorToast(error.message);
    } finally {
      setLoader(false);
      setFilterLoader(false);
    }
  };

  const postBookingData = async (data, filters) => {
    const myHeaders = new Headers();
    myHeaders.append("Accept", "application/json");
    myHeaders.append("key", process.env.REACT_APP_BASE_API_KEY);
    // myHeaders.append("key", "6rga76jtoA6Y5PPILhMAjn6nv95uHfRqR3Ykpu9GX4kw7lPpmM1");
    setLoader(true);
    myHeaders.append("Cookie", process.env.REACT_APP_COOKIE);

    const formdata = new FormData();
    {
      data.location && formdata.append("location", data.location);
    }
    if (data.children > 0) {
      for (let i = 1; i <= data.children; i++) {
        formdata.append(`childAge[${i - 1}]`, data.childAge[i - 1]);
      }
    }

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/v1/hotel-engine/check-availability?star_rating=${
          filters?.stars ? filters?.stars : ""
        }&price_range=${filters?.budget ? filters?.budget : ""}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const result = await response.json();
      setHotelData(result?.data?.properties);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching properties:", error);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const clearSelection = () => {
    // console.log("Clearing selection...");
  };

  const handleViewRoomsClickHandler = async (item) => {
    // console.log(bookingData.location);
    let hasChildAgeError = false;
    const childAge = bookingData?.childAge;
    const sanitizedChildAges = childAge
      .map((age) => (age !== "" ? age : null))
      .filter((age) => age !== null);

    const childAgeParams = sanitizedChildAges
      .map((age, index) => {
        if (age > 12) {
          alert("Child age must be between 0 and 12");
          hasChildAgeError = true;
          return;
        }
        return `&childAge[${index + 1}]=${age}`;
      })
      .join("");

    if (hasChildAgeError) {
      alert("Child age must be between 0 and 12");
      return;
    }

    // if(bookingData.location){
    //     setBookingData({
    //       ...bookingData,
    //       location: item?.location
    //     })

    // }

    try {
      await navigate(
        `/single-hotel/${item?.hotel_slug}/${item?.hotel_id}?location=${
          bookingData.location ? bookingData.location : item?.hotel_city
        }&room=1&adult=2&checkinDay=${bookingData.checkinDay}&checkinMonth=${
          bookingData.checkinMonth
        }&checkinYear=${bookingData.checkinYear}&checkoutDay=${
          bookingData.checkoutDay
        }&checkoutMonth=${bookingData.checkoutMonth}&checkoutYear=${
          bookingData.checkoutYear
        }&children=0`,
        { state: { item: item } }
      );
    } catch (error) {
      console.error("Error fetching data:", error);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };

  const sendDataToParent = (data) => {
    // console.log(data);
    postBookingData(bookingData, data);
  };

  return (
    <div id="hotelsData">
      <PageMetaData
        title={`The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries`}
        description="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        keywords="hotel management, RevCatalyst, property optimization"
      />
      <OgMetaTitles
        title={`The Best Hotels in Himachal Pradesh, India -  Mountain Mysteries`}
        type="Book hotels in Himachal Pradesh at the best budget tariffs. Explore our curated list of luxury and budget hotels with the best available prices. Compare rates and find the perfect stay with us!"
        url={`https://www.mountainmysteries.com/all-hotels`}
      />
      <BreadcrumbSchema />

      {/* <Header /> */}
      <NewUiHeader />
      <EditNewUiSearchFormHotels searchType="all_hotels" />

      {/* <AllHotelsSearchForm searchType="all_hotels" /> */}
      {/* <ListingBanner heading={`Properties In ${bookingData.location}`} /> */}
      {/* <PageLinks links={["Home", `Properties In ${bookingData.location}`]} /> */}
      <NewFilterHotels sendDataToParent={sendDataToParent} />
      <section className="common_padding pt-20 new_ui_bg">
        <div className="container">
          {/* {loader ? (
              <div className="filters">
                <div className="agent border-bottom-one">
                  <div>
                    <Skeleton width={100} />
                  </div>
                </div>
                <div className="filter_checkbox border-bottom-one">
                  <Skeleton width={150} />
                  <Skeleton count={3} width={90} />
                </div>
                <div className="filter_checkbox border-bottom-one">
                  <Skeleton width={150} />
                  <Skeleton count={3} width={90} />
                </div>
                <div className="filter_checkbox border-bottom-one">
                  <Skeleton width={150} />
                  <Skeleton count={3} width={90} />
                </div>
                <div className="filter_checkbox ">
                  <Skeleton width={150} />
                  <Skeleton count={3} width={90} />
                </div>
              </div>
            ) : (
              <FilterSection sendDataToParent={sendDataToParent} />
            )} */}

          {loader ? (
            <>
              <h3 style={{ textTransform: "capitalize" }} className="text-left">
                <Skeleton width={600} />
              </h3>
              {Array.from({ length: 9 }).map((_, index) => (
                <div className="hotel_card" key={index}>
                  <div className="hotel-content-flex hotel-main-card">
                    <div
                      className="hotel_view_img"
                      style={{ background: "#fff" }}
                    >
                      <Skeleton height={193} />
                    </div>

                    <div
                      className="hotel-content"
                      style={{ width: "100%", background: "#fff" }}
                    >
                      <div className="hotel_main">
                        <h4>
                          <b>
                            <Skeleton width={250} />
                          </b>
                        </h4>
                        <div>
                          <Skeleton width={50} />
                        </div>
                        <small>
                          <Skeleton width={150} />
                        </small>
                        <div className="agent">
                          <div>
                            <Skeleton width={100} />
                            <Skeleton width={100} />
                            <Skeleton width={100} />
                          </div>
                          <div>
                            <Skeleton width={100} />
                            <Skeleton width={100} />
                            <Skeleton width={100} />
                          </div>
                        </div>
                      </div>
                      <div className="room_rates">
                        <div className="room-flex">
                          <div>
                            <p>
                              <Skeleton width={100} />
                            </p>
                            <h5>
                              <Skeleton width={70} />
                            </h5>
                            <small>
                              <Skeleton width={50} />
                            </small>
                          </div>
                          <div className="view_room_btn">
                            <Skeleton width={100} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="">
              <div className="flex align_items_center justify_content_center flex_wrap">
                <h3 className={styles.hotel_page_heading}>
                  {bookingData.location ? (
                    <span>{`Showing ${hotelData?.length} Properties In ${bookingData.location}`}</span>
                  ) : (
                    <span> Showing {hotelData?.length} Properties</span>
                  )}
                </h3>
                {/* <div className="sorted_div">
                                    <svg
                                        width="14"
                                        height="14"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <mask
                                            id="mask0_5040_6776"
                                            style={{ maskType: "alpha" }}
                                            maskUnits="userSpaceOnUse"
                                            x="0"
                                            y="0"
                                            width="14"
                                            height="14"
                                        >
                                            <rect width="14" height="14" fill="#D9D9D9" />
                                        </mask>
                                        <g mask="url(#mask0_5040_6776)">
                                            <path
                                                d="M5.83333 10.5V9.33333H8.16667V10.5H5.83333ZM3.5 7.58333V6.41667H10.5V7.58333H3.5ZM1.75 4.66667V3.5H12.25V4.66667H1.75Z"
                                                fill="#1C1B1F"
                                            />
                                        </g>
                                    </svg>
                                    Sort by:{" "}
                                    <span className="cursor_pointer">
                                        <b>{sortedFilter?.show}</b>
                                    </span>
                                    <div className="sorted_selected">
                                        <div
                                            onClick={() => [
                                                setSortedFilter({
                                                    value: "l2hByp",
                                                    show: "Price - Low to High",
                                                }),
                                                setCurrentPage(1),
                                            ]}
                                            className="cursor_pointer p-5"
                                        >
                                            {" "}
                                            <span>Price - Low to High</span>
                                        </div>
                                        <div
                                            className="cursor_pointer p-5"
                                            onClick={() => [
                                                setSortedFilter({
                                                    value: "h2lByp",
                                                    show: "Price - high to Low",
                                                }),
                                                setCurrentPage(1),
                                            ]}
                                        >
                                            {" "}
                                            <span>Price - High to Low</span>
                                        </div>
                                    </div>
                                </div> */}
              </div>
              {hotelData && displayedData?.length > 0 ? (
                displayedData?.map((items, index) => {
                  // console.log(items);
                  return (
                    <NewUIHotelCard
                      item={items}
                      key={index}
                      bookingData={bookingData}
                      handleViewRoomsClickHandler={handleViewRoomsClickHandler}
                    />
                  );
                })
              ) : (
                <NoDataFound />
              )}

              <div className="communication_pagination">
                <CustomPagination
                  currentPage={currentPage}
                  itemsPerPage={itemsPerPage}
                  totalItems={hotelData.length} // Pass the total length of original data
                  onPageChange={handlePageChange}
                  clearSelection={clearSelection}
                />
              </div>
            </div>
          )}
        </div>
      </section>

      <NewFooterUI />

      {/* <DestinationLinks /> */}
      {/* <Footer /> */}
    </div>
  );
}

export default NewUIAllHotelsPage;
